/** アコーディオン */

/**
 * アコーディオンを初期化する
 * @param {Object} options - オプション
 * @param {number} options.speed - アニメーション速度（ms）
 */
const initAccordion = ({ speed = 300 } = {}) => {
  const OFFSET_TIME = 100; // ディレイ
  const HEIGHT_CLOSED = "--pullHeightClosed"; // 閉じた時の高さ
  const HEIGHT = "--pullHeightOpen"; // 開いた時の高さ
  const OPEN = "-open"; // 展開時のクラス
  const PC_OPEN = "-pc-open"; // PCで常時展開するアコーディオンのクラス
  // footer nav の PC/SP 統合アコーディオン用。SCSS側の mq(md) と同じ値に合わせること
  const PC_BREAKPOINT_QUERY = "(min-width: 769px)";
  const isPcLayout = () => window.matchMedia(PC_BREAKPOINT_QUERY).matches;

  window.addEventListener("load", () => {
    // PC専用に open 属性を静的付与している要素は、PC/SPのブレークポイントを跨ぐたびに
    // open状態を現在の幅に合わせ直す（リロードなしでリサイズされても表示が崩れないように）
    const pcOpenAccordions = document.querySelectorAll(`.c-accordion.${PC_OPEN}`);
    const syncPcOpenAccordions = () => {
      const pcLayout = isPcLayout();
      pcOpenAccordions.forEach((accordion) => {
        if (accordion.open !== pcLayout) {
          accordion.open = pcLayout;
        }
      });
    };
    syncPcOpenAccordions();
    window.matchMedia(PC_BREAKPOINT_QUERY).addEventListener("change", syncPcOpenAccordions);

    const accordions = document.querySelectorAll(".c-accordion");
    accordions.forEach((accordion) => {
      const summary = accordion.querySelector("summary");
      const details = accordion.querySelector(".c-accordion__contents");

      if (!summary || !details) return;

      const detailsElement = accordion;
      // 初期状態で -open クラスを持つかどうかを記録
      let hasOpenedClass = accordion.classList.contains(OPEN);

      // summary クリックイベント
      summary.addEventListener("click", (e) => {
        // PCではタイトルリンクをアコーディオン化せず、通常のリンク遷移を優先する
        if (isPcLayout() && e.target.closest("a")) return;
        // PCで常時展開するアコーディオンは、リンク以外（テキストのみの見出しなど）をクリックしても開閉させない
        if (isPcLayout() && accordion.classList.contains(PC_OPEN)) {
          e.preventDefault();
          return;
        }

        // すぐに open 属性が切り替わらないようにする
        e.preventDefault();
        // タイトル部分の高さを取得（ブラウザ幅が変更されて高さが変わった場合などにも対応できるようにクリックイベントの中で高さを毎回取得）
        const summaryHeight = summary.offsetHeight;

        // 閉じる時の高さ = タイトル部分の高さ
        detailsElement.style.setProperty(HEIGHT_CLOSED, `${summaryHeight}px`);

        // オープン / クローズ 処理
        if (!detailsElement.open) {
          // open属性を最初にセット
          detailsElement.open = true;

          // ※ コンテンツの高さはopenを付けたあとで取得しないと iOSで０になる
          detailsElement.style.setProperty(HEIGHT, `${summaryHeight + details.offsetHeight}px`);

          // open付与から少しだけ遅らせた方が動作が安定する
          setTimeout(() => {
            accordion.classList.add(OPEN);
            hasOpenedClass = true;
          }, OFFSET_TIME);
        } else {
          // 初期状態で開いているアコーディオンもアニメーションするように、閉じるときにもセット
          detailsElement.style.setProperty(HEIGHT, `${summaryHeight + details.offsetHeight}px`);

          setTimeout(() => {
            accordion.classList.remove(OPEN);
            hasOpenedClass = false;
          }, OFFSET_TIME);

          // アニメーション完了後にopen属性を削除（CSS側のアニメーション時間+少しだけ余裕をもたせている）
          setTimeout(() => {
            detailsElement.open = false;
          }, speed + OFFSET_TIME);
        }
      });

      // details 'toggle' イベント（ブラウザによるopen/close時の同期用）
      accordion.addEventListener("toggle", () => {
        if (detailsElement.open && !hasOpenedClass) {
          accordion.classList.add(OPEN);
          hasOpenedClass = true;
        } else if (!detailsElement.open && hasOpenedClass) {
          accordion.classList.remove(OPEN);
          hasOpenedClass = false;
        }
      });

      // 初期状態で開いているアコーディオンは -open クラスを付与しておく
      if (detailsElement.open && !hasOpenedClass) {
        accordion.classList.add(OPEN);
      }
    });
  });
};

const accordion = () => {
  initAccordion();
};

export { accordion };
